//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import scoreFilterJson from './../../utils/filter/scoreFilter'
import SelectDialog from './../../components/formulaComponent/selectDialog'
import UnitDialog from './../../components/formulaComponent/unitDialog'
export default {
  props: {
    /** 文案末尾的单位 */
    numEnd: {
      type: String,
      default: ''
    },
    /** 左侧的标题 */
    title: {
      type: String,
      default: ''
    },
    /** 分数 */
    scoreNum: {
      type: String,
      default: '--'
    },
    /** 控制显示和隐藏 */
    hidden: {
      type: Boolean,
      default: false
    },
    /** 结果展示的类型
     * selectUnits   单位切换类型
     */
    type: {
      type: String,
      default: ''
    },
    /**  selectUnits 类型的 单位列表 对应的key 值
    */
    units: {
      type: String
    },
    /**  selectUnits 类型的 单位列表 对应的 index 值
    */
    unitIndex: {
      type: Number
    },
    /**  selectUnits 类型的 单位列表 基础计算单位的下标
   */
    unitBaseScaleIndex: {
      type: Number,
      default: 0
    },
    /** 最大的结果 */
    scoreNumMax: {
      type: String,
      default: '--'
    },
    /** 小数点位数 */
    fixedNum: {
      type: Number,
      default: 1
    }

  },
  components: {
    SelectDialog,
    UnitDialog
  },
  data () {
    return {
      dataList3: [
        { value: 'pt_quick', name: 'PT' },
        { value: 'pt_inr', name: 'INR' }
      ],
      activeIndex: this.unitIndex,
      currentScore: '--',
      currentMaxScore: '--',
      currentNumEnd: '',
      unitSelectIndex: 0,
      showUnitDesc: false,
      isShowUnitDialog: false,
      selectTitle: ''
    }
  },
  created () {

  },
  methods: {
    /** type 为 number 类型 单位切换 */
    changeUnit () {
      let self = this
      self.isShowUnitDialog = true
    },
    /** 显示单位 选项弹窗 */
    getUnitDialogState (data) {
      this.isShowUnitDialog = data
    },
    /** 单位更改后 触发的方法 */
    setUintSelectValue (data) {
      console.log(data)
      let self = this
      self.unitSelectIndex = data
      self.changeNum(self.scoreNum, 'currentScore')
      if (self.currentMaxScore && self.currentMaxScore != '--') {
        self.changeNum(self.scoreNumMax, 'currentMaxScore')
      }
    },
    /** 数据根据单位切换的处理方法 */
    changeNum (val, key) {
      let self = this
      console.log('val2222', val)
      if ((!val) || val == '--') {
        self[key] = '--'
        return false
      }
      let index = self.unitSelectIndex || 0
      if (self.unitsList.length > 0) {
        if (self.unitsList[index].baseNum) {
          let scale = self.unitsList[index].scale / self.unitsList[self.unitBaseScaleIndex].scale
          self[key] = String(((val - self.unitsList[index].baseNum) * scale).toFixed(self.fixedNum))
          self[key] = self.formatNumber(self[key], self.fixedNum)
        } else {
          let scale = self.unitsList[index].scale / self.unitsList[self.unitBaseScaleIndex].scale
          self[key] = String((val * scale).toFixed(self.fixedNum))
          self[key] = self.formatNumber(self[key], self.fixedNum)
        }
      } else {
        self[key] = val
      }
    },
    formatNumber (num, fixedNum = 0) {
      // 将数字转换为字符串并检查小数点后的值
      const numStr = num
      const number = Number(numStr)
      const decimalIndex = numStr.indexOf('.')

      if (decimalIndex === -1) {
        // 如果没有小数点，直接返回整数部分
        return numStr
      }

      // 获取小数点后的部分
      let decimalPart = numStr.slice(decimalIndex + 1)
      decimalPart = decimalPart.replace(/0+$/, '')
      console.log(decimalPart, 88888)
      // 检查小数点后是否全为0
      if (/^0+$/.test(decimalPart)) {
        // 如果全为0，则返回整数部分
        return number.toFixed(0)
      }

      if (decimalPart) {
        return Math.floor(number) + '.' + decimalPart
      }
      // 否则，保留4位小数并返回
      return number
    }
  },
  computed: {
    /** 单位 list */
    unitsList () {
      let self = this
      let list = []
      if (self.units) {
        list = scoreFilterJson[self.units] || []
        if (list.length <= self.unitIndex) {
          self.unitSelectIndex = 0
        } else {
          self.unitSelectIndex = self.unitIndex || 0
        }
      }
      return list
    }
  },
  watch: {
    /** 监测结果 */
    scoreNum (newVal) {
      let self = this
      console.log(newVal)
      if (self.type == 'selectUnits') {
        self.changeNum(newVal, 'currentScore')
      }
    },
    /** 监测结果 */
    scoreNumMax (newVal) {
      let self = this
      console.log(newVal)
      if (self.type == 'selectUnits') {
        self.changeNum(newVal, 'currentMaxScore')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/formulaComponent/formulaScore.vue